import React from 'react';
import SurveyItem from './SurveyItem';
import SurveyEmptyState from './SurveyEmptyState';
import SingleItemLoadingState from '../../shared/components/SingleItemLoadingState';
import { isSurveyTakenFromLocalStorage } from '../../shared/dataUtils';
import { isAccountLoggedIn } from '../../shared/apiUtils';

interface Props {
  surveys: any,
  showSurvey: any,
  loading: boolean,
  nextPage: any,
  loadNextSurveyPage: any,
}

class SurveyList extends React.Component<Props, {}> {
  constructor(props) {
    super(props);
    this.showSurvey = this.showSurvey.bind(this);
  }

  showSurvey(e) {
    this.props.showSurvey(e);
  }

  shouldShowSurvey(survey) {
    let shouldShowSurvey = true;
    if(!survey.can_be_taken || !survey.allow_select) {
      shouldShowSurvey = false;
    } else if(!isAccountLoggedIn() && isSurveyTakenFromLocalStorage(survey.id)) {
      shouldShowSurvey = false;
    }
    return shouldShowSurvey;
  }

  render() {
    let { surveys, loading, nextPage } = this.props;
    let eventSurveys = [];
    let sessionSurveys = [];
    for (let index = 0; index < surveys.length; index++) {
      const survey = surveys[index];
      if(this.shouldShowSurvey(survey)) {
        if(survey.surveyable_type == "Event") {
          eventSurveys.push(survey);
        } else {
          sessionSurveys.push(survey);
        }
      }
    }
    let noSurveysAvailable = false;
    if(eventSurveys.length == 0 && sessionSurveys.length == 0) {
      noSurveysAvailable = true;
    }
    return(
      <div className="p3">
        {loading &&
          <React.Fragment>
            <SingleItemLoadingState/>
          </React.Fragment>
        }
        {!loading && noSurveysAvailable &&
          <><SurveyEmptyState/></>
        }
        {eventSurveys.length > 0 &&
          <React.Fragment>
            <div className="fs-md cs-black fw-sb mb2">Event Surveys</div>
            {eventSurveys.map((survey) => {
              return(
                <SurveyItem
                  surveyName={survey.name}
                  survey={survey}
                  clickedSurvey={this.showSurvey}
                  key={"survey-"+survey.id}
                />
              )
            })}
          </React.Fragment>
        }
        {sessionSurveys.length > 0 &&
          <React.Fragment>
            <div className="fs-md cs-black fw-sb my2">Session Surveys</div>
            {sessionSurveys.map((survey) => {
              return(
                <SurveyItem
                  surveyName={survey.surveyable.name}
                  survey={survey}
                  clickedSurvey={this.showSurvey}
                  key={"survey-"+survey.id}
                />
              )
            })}
          </React.Fragment>
        }
        {nextPage &&
          <div className="text-center mt1 mb3">
            <div className="btn cs-btn-gray-outline" onClick={this.props.loadNextSurveyPage}>
              {loading ? "Loading..." : "Load More"}
            </div>
          </div>
        }
      </div>
    );
  }
}

export default SurveyList;
